module.exports = __webpack_public_path__ + "img/82.9.TU.bd2640d1.png";